import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Theme } from '@mui/material';
import { QlfTitle, colorPalette, useQlfTranslation } from '@qualifio/ui-commons';
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { makeStyles } from '@mui/styles';
import { DetailForm } from '../../shared/layout/DetailForm';
import { DomainTable } from './DomainTable';
import { QlfMasterDetailContainer } from '../../shared/layout/QlfMasterDetailContainer';
import { useConfiguration } from '../../ConfigurationContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  title: {
    textAlign: 'center',
    justifyItems: 'center',
  },
  description: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  cnameDescription: {
    textAlign: 'center',
    alignItems: 'center',
    marginBottom: '30px',
  },
  content: {
    marginLeft: spacing(1),
    marginRight: spacing(1),
  },
  cnameBox: {
    border: '1px solid',
    borderColor: colorPalette.grey.main,
    borderRadius: '5px',
    padding: '5px',
    marginLeft: '10px',
    backgroundColor: colorPalette.grey.light,
  },
  copyButton: {
    backgroundColor: 'transparent',
    '&:hover': {
      color: colorPalette.turquoise.main,
      backgroundColor: 'transparent !important',
    },
  },
  iconButton: {
    fontSize: '16px',
    color: colorPalette.grey.main,
    minWidth: 40,
    backgroundColor: 'transparent !important',
    '&:hover': {
      color: colorPalette.turquoise.main,
    },
  },
}));

export function DomainsDetails() {
  const classes = useStyles();

  const { t } = useQlfTranslation('translation');
  const { cnameDomain } = useConfiguration();

  return (
    <QlfMasterDetailContainer isAccountLevel>
      <DetailForm>
        <DetailForm.Form className={classes.content}>
          <div className={classes.title}>
            <QlfTitle variant="h2" separator={{ state: 'center' }}>
              {t('subdomain.edition.title')}
            </QlfTitle>
          </div>
          <div className={classes.description}>{t('subdomain.edition.description')}</div>
          <div className={classes.cnameDescription}>
            <span>{t('subdomain.edition.cname')}</span>
            <span className={classes.cnameBox}>
              {cnameDomain}
              <IconButton
                className={classNames(classes.iconButton, classes.copyButton)}
                onClick={() => navigator.clipboard.writeText(cnameDomain)}
              >
                <FontAwesomeIcon icon={faCopy} />
              </IconButton>
            </span>
          </div>
          <DomainTable />
        </DetailForm.Form>
      </DetailForm>
    </QlfMasterDetailContainer>
  );
}
